import { render, staticRenderFns } from "./CarOilSale.vue?vue&type=template&id=1911a567"
import script from "./CarOilSale.vue?vue&type=script&lang=js"
export * from "./CarOilSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports